import HtmlImg from "../../assets/html5.webp";
import JavascriptImg from "../../assets/javascript.png";
import CssImg from "../../assets/css.png";
import ReactImg from "../../assets/react.svg";
import JestImg from "../../assets/jest.png";
import GitImg from "../../assets/git.png";
import GitHubImg from "../../assets/gitHub.jpeg";
import TypescriptImg from "../../assets/typescript.jpeg";
import ApiRestImg from "../../assets/api.png";
import FigmaImg from "../../assets/figma.png";
import { Title } from "../Title";
import { PillCard } from "../PillCard";
import { Col, Row } from "react-bootstrap";
import { useLanguage } from "../../hooks/LanguageProvider";
import { Underline } from "../Title/styles";
import { Subtitle } from "./styles";

export const Technologies = () => {
  const { language } = useLanguage();

  return (
    <section id="tecnologies" className="mt-5 py-1">
      <Title title={language === "US" ? "Technologies" : "Tecnologias"} />
      <div className="d-flex justify-content-end text-end mb-5">
        <div>
          <Subtitle>Front-end</Subtitle>
          <Underline />
        </div>
      </div>
      <Row
        xs={2}
        md={2}
        lg={3}
        xl={4}
        className="g-4 justify-content-start mb-3"
      >
        <Col>
          <PillCard image={HtmlImg} title="HTML" />
        </Col>
        <Col>
          <PillCard image={JavascriptImg} title="Javascript" />
        </Col>
        <Col>
          <PillCard image={CssImg} title="CSS" />
        </Col>
        <Col>
          <PillCard image={ReactImg} title="React" />
        </Col>
        <Col>
          <PillCard image={TypescriptImg} title="Typescript" />
        </Col>
        <Col>
          <PillCard image={ApiRestImg} title="Api Rest" />
        </Col>
        <Col>
          <PillCard image={JestImg} title="Jest" />
        </Col>
      </Row>
      <div className="d-flex justify-content-end text-end mb-5">
        <div>
          <Subtitle>{language === "US" ? "Others" : "Outros"}</Subtitle>
          <Underline />
        </div>
      </div>
      <Row xs={2} lg={3} xl={4} className="g-4 justify-content-start mb-3">
        <Col>
          <PillCard image={GitImg} title="Git" />
        </Col>
        <Col>
          <PillCard image={GitHubImg} title="GitHub" />
        </Col>
        <Col>
          <PillCard image={FigmaImg} title="Figma" />
        </Col>
      </Row>
    </section>
  );
};
